import { Controller } from "remult";

@Controller("association-position-methods")
export class AssociationPositionMethods {}
